import React from "react";
import classes from "./CourtCard.module.css";
import { logo } from "../../constant";
import { LocationIcon } from "../../constant";
import DotBall from "../DotBall";
import LabelValue from "../LabelValue";
import { formatNumberWithCommas } from "../../helpers";
import MultiLineEllipsis from "../MultiLineEllipsis";
const DetailCard = ({ court }) => {
  console.log("court",court)
  return (
    <div className={classes.detailCard}>
      <figure className={classes.figureFrame}>
        <img src={ court?.courtImages?.find((image) => image?.companyImageTypeId == 1)?.companyImage} alt={court?.courtName} />
      </figure>
      <div className={classes.detailContent}>
        <h2 className={classes.courtName}>{court?.courtName}</h2>
        <MultiLineEllipsis className={classes.courtDescription} line={2} Tag="p" >{court?.location?.locationName}</MultiLineEllipsis>
      </div>
    </div>
  );
};

const Pill = ({ label, leftIcon }) => {
  return (
    <div className={classes.pillContainer}>
      {leftIcon}
      <span className={classes.pill}>{label}</span>
    </div>
  );
};
function findMinimumCourtMinAmount(courtTimings) {
  console.log("courts Timings", courtTimings);
  if (!courtTimings || courtTimings.length === 0) {
    return null;
  }

  return Math.min(...courtTimings.map((timing) => timing.courtMinAmount));
}

const CourtCard = ({ court, menu }) => {
  return (
    <div className={classes.courtCard}>
      <header className={classes.header}>
        <DetailCard court={court} />
        {menu}
      </header>
      <div className={classes.body}>
        <Pill
          leftIcon={<DotBall bookingStatus={court?.courtStatusId} />}
          label={court?.courtStatusId === 1 ? "Active" : "Maintenance"}
        />
        <Pill leftIcon={<LocationIcon />} label={court?.courtSportType} />
        <Pill
          leftIcon={<LocationIcon />}
          label={
            <LabelValue
              className={classes.pillLabel}
              label={formatNumberWithCommas(
                findMinimumCourtMinAmount(court?.courtTimings)
              )}
              value={"Price Starts from "}
            />
          }
        />
      </div>
    </div>
  );
};

export default CourtCard;
